/** The sidebar's keyboard toggle (1.I-1 deliverable 6): Mod-\ (⌘\ on Apple platforms, Ctrl+\ elsewhere). */

export interface ToggleKeyEvent {
  readonly key: string;
  readonly metaKey: boolean;
  readonly ctrlKey: boolean;
  readonly altKey: boolean;
  readonly shiftKey: boolean;
  readonly isComposing?: boolean;
}

/** Decides from `apple`, never from the machine it runs on. */
export function isSidebarToggle(event: ToggleKeyEvent, apple: boolean): boolean {
  if (event.isComposing) return false;
  if (event.key !== '\\') return false;
  const mod = apple ? event.metaKey : event.ctrlKey;
  const other = apple ? event.ctrlKey : event.metaKey;
  if (!mod) return false;
  return !other && !event.altKey && !event.shiftKey;
}
